import { redirect } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { ConfirmDialog } from '@/components/confirm-dialog'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { getGetUsersProfileQueryKey } from '@/types/origin-point-engine'
import { useAuth } from '../hooks/use-auth'
interface SignOutDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SignOutDialog({ open, onOpenChange }: SignOutDialogProps) {
  const { handleLogout } = useAuthStore((s) => s.handlers)
  const { authLogoutMutationAsync } = useAuth()
  const queryClient = useQueryClient()

  const handleSignOut = () => {
    handleLogout(authLogoutMutationAsync, () => {
      // 清除用户资料的 React Query 缓存，防止切换账户时显示旧用户信息
      queryClient.removeQueries({ queryKey: getGetUsersProfileQueryKey() })
      redirect({
        to: '/',
      })
    })
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title='退出登录'
      desc='确定要退出登录吗？'
      confirmText='退出登录'
      destructive
      handleConfirm={handleSignOut}
      className='sm:max-w-sm'
    />
  )
}
